
  import { Vue, Component } from 'vue-property-decorator';
  import { data } from "./mc-tally.data";
  import { MealCountDtoViewModel } from '@/view-models';
  import { clone } from '@/utils';

  @Component
  export default class McTallyTests extends Vue {
    model = clone<MealCountDtoViewModel>(data.model);

    fluent = {};
    created() {
      this.model = data.model;
    }

    mounted() {
    }

    inputChanged() {

    }
  }
